module.exports = __webpack_public_path__ + "img/26.5c9b586f.png";